import { TOGGLE_SGZ_SPECIFIC_DETAIL_PANEL } from "./displaySgzSpecificDetailPanelReducer"

export const toggleSgzSpecificDetailPanel = (value) => ({
    type: TOGGLE_SGZ_SPECIFIC_DETAIL_PANEL,
    payload: value
})
